import React, { useState, useEffect } from "react";
import { generateClient } from "aws-amplify/data";
import { list, getUrl } from "aws-amplify/storage";
import { Banner } from "../../components/shared";
import { fetchAuthSession } from "aws-amplify/auth";

const client = generateClient();

async function pickAuthMode() {
  try {
    const s = await fetchAuthSession();
    return s.tokens ? "userPool" : "identityPool";
  } catch {
    return "identityPool";
  }
}

export default function BannerDisplay() {
  const [bannerData, setBannerData] = useState(null);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const authMode = await pickAuthMode();
        // Obtener el banner desde AppSync
        const { data: items, error: error } = await client.models.Banner.list({
          authMode,
        });
        console.log("Banner items: ", items);
        if (items.length > 0) {
          const banner = items[0];
          setBannerData(banner);

          // Asegurar que la ruta de la carpeta termina con '/'
          const folderPath = banner.imageFolder.endsWith("/")
            ? banner.imageFolder
            : `${banner.imageFolder}/`;

          // Obtener la lista de archivos en la carpeta especificada
          const filesResult = await list({
            path: folderPath,
          });

          // Verificar si 'items' está definido y es un array
          const files = Array.isArray(filesResult.items)
            ? filesResult.items
            : [];

          // Filtrar y ordenar las imágenes
          const imageFiles = files
            .filter((item) => item.path.match(/\.(jpg|jpeg|png|gif)$/i))
            .sort((a, b) => a.path.localeCompare(b.path));

          // Obtener las URLs públicas de las imágenes
          const imageUrls = await Promise.all(
            imageFiles.map(async (item) => {
              const urlResult = await getUrl({
                path: item.path,
              });
              return urlResult.url.href;
            }),
          );

          setImages(imageUrls);
        }
      } catch (error) {
        console.error("Error al obtener los datos del banner:", error);
      }
    };

    fetchBanner();
  }, []);

  if (!bannerData) return <div>Cargando...</div>;

  return (
    <Banner images={images} text={bannerData.text} autoPlayInterval={3000} />
  );
}
